import _export from '../internals/export.js';
import descriptors from '../internals/descriptors.js';
import objectPrototypeAccessorsForced from '../internals/object-prototype-accessors-forced.js';
import toObject$1 from '../internals/to-object.js';
import toPropertyKey$1 from '../internals/to-property-key.js';
import objectGetPrototypeOf from '../internals/object-get-prototype-of.js';
import '../internals/object-get-own-property-descriptor.js';
import { __exports as objectGetOwnPropertyDescriptor } from '../../../../../../_virtual/object-get-own-property-descriptor.js';

var $ = _export;
var DESCRIPTORS = descriptors;
var FORCED = objectPrototypeAccessorsForced;
var toObject = toObject$1;
var toPropertyKey = toPropertyKey$1;
var getPrototypeOf = objectGetPrototypeOf;
var getOwnPropertyDescriptor = objectGetOwnPropertyDescriptor.f; // `Object.prototype.__lookupGetter__` method
// https://tc39.es/ecma262/#sec-object.prototype.__lookupGetter__

if (DESCRIPTORS) {
  $({
    target: 'Object',
    proto: true,
    forced: FORCED
  }, {
    __lookupGetter__: function __lookupGetter__(P) {
      var O = toObject(this);
      var key = toPropertyKey(P);
      var desc;

      do {
        if (desc = getOwnPropertyDescriptor(O, key)) return desc.get;
      } while (O = getPrototypeOf(O));
    }
  });
}
